// extracted by mini-css-extract-plugin
module.exports = {"boardColumn":"BoardColumn_boardColumn__2W3OV","boardColumn__header":"BoardColumn_boardColumn__header__25-8h"};